import Svg, { SvgProps, Path } from 'react-native-svg';

export const NotFoundIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 60 60" width={60} height={60} fill="#FFFFFF" {...props}>
    <Path d="M26 6C14.978 6 6 14.978 6 26s8.978 20 20 20c4.793 0 9.195-1.702 12.645-4.527l11.94 11.941a2 2 0 1 0 2.83-2.828L41.472 38.645A19.894 19.894 0 0 0 46 26c0-11.022-8.978-20-20-20Zm0 4c8.86 0 16 7.14 16 16s-7.14 16-16 16-16-7.14-16-16 7.14-16 16-16Zm-7 10a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm14 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-7 10c-4.119 0-7.195 2.395-7.195 2.395a2.002 2.002 0 0 0 2.39 3.21S23.491 34 26 34c2.51 0 4.805 1.605 4.805 1.605a2.002 2.002 0 1 0 2.39-3.21S30.12 30 26 30Z" />
  </Svg>
);
